import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { styled } from "@mui/material/styles";
import { faLinkedin, faTiktok, faMicrosoft, faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { faMagnifyingGlass, faDisplayChartUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Text from "../Text/Text.js";
const icons = {
  google: faGoogle,
  facebook: faFacebook,
  microsoft: faMicrosoft,
  tiktok: faTiktok,
  linkedin: faLinkedin,
  chart: faDisplayChartUp,
  search: faMagnifyingGlass
};
const HeaderWrapper = styled(Box)(({
  theme
}) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  gap: theme.sizes.spacing["06"],
  justifyContent: "flex-start",
  width: "100%",
  height: theme.fonts.lineHeight["leading-10"],
  padding: theme.sizes.spacing.none,
  boxSizing: "border-box"
}));
const ColumnWrapper = styled(Box)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.sizes.spacing["04"]
}));
const DescriptionWrapper = styled(Box)(({
  theme
}) => ({
  color: theme.colors.text.tertiary
}));
const HeaderSkeleton = styled(Skeleton)(({
  theme
}) => ({
  height: theme.sizes.spacing["07"],
  minWidth: "13rem",
  marginBottom: theme.sizes.spacing["04"]
}));
const Header = (t0) => {
  const $ = c(18);
  const {
    title,
    icon: t1,
    isMarkdown: t2,
    description: t3,
    help: t4,
    variant: t5
  } = t0;
  const icon = t1 === void 0 ? null : t1;
  const isMarkdown = t2 === void 0 ? false : t2;
  const description = t3 === void 0 ? void 0 : t3;
  const help = t4 === void 0 ? null : t4;
  const variant = t5 === void 0 ? "h4" : t5;
  if (!title) {
    return;
  }
  let t6;
  if ($[0] !== icon) {
    t6 = icon && /* @__PURE__ */ jsx(FontAwesomeIcon, { icon: icons[icon], size: "2x" });
    $[0] = icon;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== title) {
    t7 = !title && /* @__PURE__ */ jsx(HeaderSkeleton, { variant: "text", width: "5rem", height: "1.5rem" });
    $[2] = title;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== help || $[5] !== isMarkdown || $[6] !== title || $[7] !== variant) {
    t8 = title && /* @__PURE__ */ jsx(Text, { variant, text: `${title}`, help, isMarkdown });
    $[4] = help;
    $[5] = isMarkdown;
    $[6] = title;
    $[7] = variant;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6 || $[10] !== t7 || $[11] !== t8) {
    t9 = /* @__PURE__ */ jsxs(HeaderWrapper, { children: [
      t6,
      t7,
      t8
    ] });
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== description) {
    t10 = description && /* @__PURE__ */ jsx(DescriptionWrapper, { children: /* @__PURE__ */ jsx(Text, { variant: "body1", text: description }) });
    $[13] = description;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = /* @__PURE__ */ jsxs(ColumnWrapper, { children: [
      t9,
      t10
    ] });
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};
export {
  Header as default
};
